export default __webpack_public_path__ + "9fce0ec26b1fbedc94c844a0b08ac5da.png";